import classNames from 'classnames';
import { useEffect, useId, useState } from 'react';

import {
  GridContainer,
  Text,
  useViewport,
  type TextVariant,
} from '@farmersdog/corgi-x';

import { useRoutes } from '../../static-context';

import { Digest } from './Digest';
import styles from './DigestHighlightsSlice.css';
import { RelatedBreeds } from './RelatedBreeds';
import { getDefaultDigestSlice, getRelatedBreedLinks } from './utils';

import type { DigestHighlightsSliceType } from './types';
import type { ClientRoute } from '../../static-context';

export interface DigestHighlightsSliceProps {
  breed?: string;
  slice?: DigestHighlightsSliceType;
  buildId: string;
  breedLinks?: ClientRoute[];
}

export function DigestHighlightsSlice({
  breed,
  slice,
  buildId,
  breedLinks: breedLinksProp,
}: DigestHighlightsSliceProps) {
  const id = useId();
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  const digestSliceWithLinks = getDefaultDigestSlice({
    slice,
    buildId,
  });

  const allRoutes = useRoutes();
  const breedLinks =
    breedLinksProp ?? getRelatedBreedLinks({ allRoutes, buildId });

  const viewport = useViewport();
  const isLargeViewport = hasMounted && viewport.lg;

  const titleVariant: TextVariant = isLargeViewport
    ? 'heading-40'
    : 'heading-28';

  return (
    <>
      {breed && (
        <section className={styles.section} aria-labelledby={id}>
          <GridContainer>
            <Text
              className={classNames(styles.readMore, styles.fullWidth)}
              id={id}
              as="h2"
              variant={titleVariant}
              color="kale-3"
              weight="bold"
            >
              Read more about dog food and {breed}
            </Text>
            <Digest breed={breed} slice={digestSliceWithLinks} />
            <RelatedBreeds links={breedLinks} />
          </GridContainer>
        </section>
      )}
    </>
  );
}
